// import get from 'lodash/get';
// import querySerializer from 'qs';

// import { fetchEnvData } from 'dux/env';
import { translations } from '@biw/contests-core';
// import { addError, Errors } from 'dux/errors';
import { getUserData } from 'dux/user';
import { setUserData } from 'dux/user/actions';
import { getLocaleCode, getUserAuthenticated } from 'dux/user/selectors';

import setFetchOptions from 'app/utils/fetch-options';
import { Dispatch } from 'app/types/redux';

// import * as actions from './actions';
// import * as selectors from './selectors';
// import routesMap from './routes';
// import { ERROR } from './types';
// import { fetchComponent, getComponent } from './component-loader';

// const noop = () => {};

// const fetchClientData = () => async dispatch => {
//     try {
//         await dispatch( clientActions.getClientData() );
//     } catch ( error ) {
//         dispatch( addError( error, Errors.ERROR_CLIENT_FETCHCLIENTDATA ) );
//         throw error;
//     }
// };

// async function getRouteComponent( routeType, dispatch, getState ) {
//     let Component = getComponent( routeType );
//     if ( !Component ) {
//         Component = await fetchComponent( routeType, get( routesMap, `${routeType}.getComponent`, noop ) );
//     }

//     // Need to check here because browser caching will sometimes return a component
//     //  even though the store isn't aware of it
//     if ( !selectors.getComponentIsLoaded( getState(), routeType ) ) {
//         dispatch( actions.componentIsLoaded( routeType ) );
//     }
//     return Component;
// }

// initializeEnvData only runs once on application start
export async function initializeEnvData( dispatch: Dispatch, getState: any ) {
    setFetchOptions();
    await Promise.all( [
        // dispatch( fetchClientData() ), // Need to figure out the company service
        // dispatch( fetchEnvData() )
        dispatch( translations.actions.getLocaleBundle( 'en_US' ) ),
    ] );

    await dispatch( getUserData() );

    let locale = {} as any;
    const isAuthenticated = getUserAuthenticated( getState() );
    if ( isAuthenticated ) {
        // if the user is authenticated, grab the locale setting from the newly fetched user data
        locale.code = getLocaleCode( getState() );
        // set the userLocale in the client settings
        dispatch( translations.actions.setUserLocale( locale.code ) );
    } else {
        // grab the locale setting returned by the client payload that is resolved by the user's browser settings
        locale = translations.selectors.getUserLocale( getState() );
        // apply the setting to the user data for the login page to use on locale selection
        dispatch( setUserData( { locale: locale.code } ) );
    }
    locale = translations.selectors.getUserLocale( getState() );
    document.getElementsByTagName( 'html' )[ 0 ].setAttribute( 'lang', locale.intlCode );
    const bundle = translations.selectors.getUserBundle( getState() );
    if ( !Object.keys( bundle ).length ) {
        console.warn( 'No bundle data found!!!' );
        // await dispatch( translations.selectors.getLocaleBundle( locale.code ) );
    }
}

export const initialDispatch = async ( dispatch: Dispatch, getState: any ) => {
    // let hasInitError = false;
    try {
        await dispatch( initializeEnvData );
    } catch ( error ) {
        console.error( error );
        // hasInitError = true;
    }

    // await router.initialDispatch();

    // if ( hasInitError ) {
    //     return dispatch( redirect( { type: ERROR } ) );
    // }

    // const client = getState().client || {};
    // if ( client.bundleList && Object.keys( client.bundleList ).length === 0 ) {
    //     return dispatch( redirect( { type: ERROR } ) );
    // }
};

// const router = connectRoutes( routesMap, {
//     querySerializer,
//     restoreScroll: createRestoreScroll( { manual: true } ),
//     initialDispatch: false,
//     onBeforeChange: ( dispatch, getState, event ) => {
//         const routeType = get( event, 'action.type', '' );
//         get( routesMap, `${routeType}.beforeEnter`, noop )( dispatch, getState, event );
//     },
//     onAfterChange: async ( dispatch, getState ) => {
//         const routeType = selectors.getCurrentRouteType( getState() );
//         const loadingTimeoutId = setTimeout( () => {
//             dispatch( actions.routeIsLoading() );
//         }, 100 );

//         await Promise.all( [
//             getRouteComponent( routeType, dispatch, getState ),
//             get( routesMap, `${routeType}.afterEnter`, noop )( dispatch, getState )
//         ] );

//         clearTimeout( loadingTimeoutId );

//         // in case a redirect has happened in the `afterEnter` async hook or user action,
//         // do not complete the route transition
//         if ( selectors.getCurrentRouteType( getState() ) === routeType ) {
//             dispatch( actions.routeLoaded( routeType ) );
//             dispatch( actions.restoreScroll() );
//         }
//     }
// } );

// export default router;
